import React from 'react';
import { Box } from '@mui/material';

interface RolePillProps {
  role: string;
  size?: 'small' | 'medium' | 'large';
}

/**
 * A reusable component for displaying user roles as styled pills
 */
const RolePill: React.FC<RolePillProps> = ({ role, size = 'medium' }) => {
  // Determine if role is admin (case insensitive)
  const isAdmin = typeof role === 'string' && role.toLowerCase() === 'admin';

  // Set sizing based on the size prop
  const getSizing = () => {
    switch (size) {
      case 'small':
        return {
          px: 1.5,
          py: 0.25,
          fontSize: '0.7rem',
          borderRadius: '12px',
        };
      case 'large':
        return {
          px: 2.5,
          py: 0.75,
          fontSize: '0.85rem',
          borderRadius: '20px',
        };
      case 'medium':
      default:
        return {
          px: 2,
          py: 0.5,
          fontSize: '0.75rem',
          borderRadius: '16px',
        };
    }
  };

  return (
    <Box
      component="span"
      sx={{
        ...getSizing(),
        fontWeight: 'bold',
        textTransform: 'uppercase',
        backgroundColor: isAdmin ? 'primary.main' : 'success.main',
        color: 'white',
        display: 'inline-block',
        letterSpacing: '0.5px',
        boxShadow: '0 1px 3px rgba(0,0,0,0.1)'
      }}
    >
      {role}
    </Box>
  );
};

export default RolePill;
